'use client';

import type { ElementType, ReactNode } from 'react';
import { createContext, useContext, useMemo } from 'react';

export interface LinkLikeProps {
   href: string;
   target?: string;
   [prop: string]: unknown;
}

export interface ImageLikeProps {
   src: string;
   alt: string;
   [prop: string]: unknown;
}

interface UIContextValue {
   Link: ElementType<LinkLikeProps>;
   Image: ElementType<ImageLikeProps>;
}

const UIContext = createContext<UIContextValue>({
   Link: 'a',
   Image: 'img',
});

export interface UIProviderProps {
   children: ReactNode;
   linkComponent?: ElementType<LinkLikeProps>;
   imageComponent?: ElementType<ImageLikeProps>;
}

export function UIProvider({
   children,
   linkComponent: Link = 'a',
   imageComponent: Image = 'img',
}: UIProviderProps) {
   const value = useMemo(
      () => ({
         Link,
         Image,
      }),
      [Link, Image]
   );

   return <UIContext.Provider value={value}>{children}</UIContext.Provider>;
}

export function useUIContext() {
   return useContext(UIContext);
}
